// ワークフロー一覧ソート種別
// ソートプルダウンのほか、リストヘッダークリックによるソートにも使用しているので順番を変更しないこと
export enum WorkflowListSortItemKinds {
  ReceptionDate,
  CreateDate,
  UpdateDate,
  PatientId,
  PatientKana,
  CompanyName,
  FormatName,
  DepartmentName,
  CreateUser,
  InputSection,
  PatientNameKanji,
  WaitName,
  Status,
  TimeLimit,
  Delivery,
  CreateLimitDate,
  DeliveryLimitDate,
  FinishDate,
  ReceptionNumber,
  Manager,
  IsPaper,
  NextMessage,
  ReceiptDate,
  GeneralFlag1,
  TemporarySave,
  InOutType,
  GeneralComment,
  // 以下は特殊な値を定義する
  MultiCondition = 100, // 複数条件
  PresetMin = 101,  // プリセット用最小オフセット
  PresetMax = 120,  // プリセット用最大オフセット
}
